import { gql } from "@apollo/client";

export const GET_SHARE_LIST = gql`
   query Query($limit: Int!, $offset: Int!, $searchData: String, $noteId: String, $shareCodeList: Boolean) {
      getListForSharingNotes(
         limit: $limit
         offset: $offset
         searchData: $searchData
         noteId: $noteId
         shareCodeList: $shareCodeList
      ) {
         sharingNotesList {
            createdAt
            groupId
            sent
            shareWithData {
               mobileNo
               name
               title
               dob
               members {
                  initials
                  email
                  colorCode
                  mobileNo
                  name
                  title
                  userId
               }
               initials
               email
               colorCode
            }
            userId
         }
         totalCount
      }
   }
`;

export const SEND_NOTES = gql`
   mutation AddSharingNoteDetails($createShareNote: createShareNote) {
      addSharingNoteDetails(createShareNote: $createShareNote) {
         status {
            message
            code
            success
         }
      }
   }
`;

export const ADD_EXTERNAL_USER = gql`
   mutation Mutation($addExternalUser: addExternalUserInput) {
      addExternalUser(addExternalUser: $addExternalUser) {
         status {
            code
            success
            message
         }
      }
   }
`;

export const SEND_NOTES_EHR = gql`
   mutation Mutation($noteId: String!) {
      sendNoteToEHR(noteId: $noteId) {
         success
         message
      }
   }
`;
